/**
 * Created by asiulik on 20.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../store/favouriteStore'], function($, _, EventEmitter, FavouriteStore){


    var config = {
        calculatorOverlaySelector: "#calculatorOverlay",
        calculatorOverlayMany: ".hide-for-now-on-demand",
        sliderTriggerSelector: "[data-calculator-overlay-trigger]"
    };

    function OverlayCalculator(overlayInstance){
        this.overlay = overlayInstance;
    }

    OverlayCalculator.prototype = _.clone(EventEmitter.prototype);

    OverlayCalculator.prototype.init = function(){
        this.favourtiesStore = new FavouriteStore();
        this.$triggerElements = $(config.sliderTriggerSelector);
        this.$calculatorOverlay = $(config.calculatorOverlaySelector);
        this.bindEvents();

    };

    OverlayCalculator.prototype.bindEvents = function(){

        var _this = this;

            this.$triggerElements.on({
            click: function(e){
                e.preventDefault();
                var $this = $(this);

                if ( $('body').hasClass('page--assortmentitem') ) {

                    var favs = _this.favourtiesStore.getFavourites();

                    if ( !!favs && favs.hasOwnProperty("dashboard")) {

                        if ( favs['content']['products'].length === 0 ) {

                            _this.openCalculatorOverlay($this);

                        } else {

                            if ( favs['content']['products'].length > 0 ) {

                                var currentProduct = _this.verifyCurrentPageProduct(favs);

                                var productExistInFavs =  currentProduct['exist'];
                                var productData = currentProduct['product'];
                                var dashboardData = currentProduct['dashboard'];

                                if ( productExistInFavs ) {

                                    if ( _this.updateCalculatorView(productData, dashboardData) ) {
                                        _this.openCalculatorOverlay($this);
                                    }
                                } else {

                                    if ( _this.updateCalculatorView({}, dashboardData) ) {
                                        _this.emit('overlay:calculator:calculateBeforeOpen', currentProduct)
                                    }
                                }
                            }

                        }
                    } else {
                        _this.openCalculatorOverlay($this);
                    }

                } else {
                    _this.openCalculatorOverlay($this);
                }

            }
        })

    };

    OverlayCalculator.prototype.openCalculatorOverlay = function($triggerElement){
        this.overlay.openOverlay(
            this.$calculatorOverlay
        );
    };

    OverlayCalculator.prototype.openCalculatorOverlayAfterCalculation = function(){

        var favs = this.favourtiesStore.getFavourites();

        var currentProduct = this.verifyCurrentPageProduct(favs);

        var productData = currentProduct['product'];
        var dashboardData = currentProduct['dashboard'];

        this.updateCalculatorView(productData, dashboardData);

        this.overlay.openOverlay(
            this.$calculatorOverlay
        );

    };

    OverlayCalculator.prototype.updateCalculatorView = function(productData, dashboardData){

        var $rowRange = $('#rowRange');
        const $rowRangeTable = $('#rowRangeMain');
        var $calculationFormReset = $('#calculationFormReset');

        const getPriceComponents = cumulatedPrice => {
            const priceComponents = cumulatedPrice.split(' ');
            if (priceComponents.length === 0) {
                return {
                    price: cumulatedPrice,
                    currency: ''
                }
            }

            const currency = priceComponents[0];
            delete priceComponents[0];
            const priceWithoutCurrency = priceComponents.join(' ');

            return {
                price: priceWithoutCurrency.trim(),
                currency: currency
            }
        }

        if ( productData ) {

            $rowRange.find('.range-qm-value').html(productData['qmRange']);
            $rowRange.find('.range-price-value').html(productData['price']);

            var template = $('#comment-template').html();
            var compiledTemplate = _.template(template);
            var $additionalMarkupTpl = $('.rowRangeOther');

            if ( productData['currentSorting'] ) {
                $(config.calculatorOverlayMany).show();
            }
            if ( productData.hasOwnProperty('individualPrices') && productData.many && !productData['currentSorting'] ) {

                var additionalMarkup = '';

                $.each(productData['individualPrices'], function (index, value) {
                    const rangeArea = getPriceComponents(value.qmRange);
                    const rangePrice = getPriceComponents(value.price);
                    $rowRangeTable.find('th .currency').text(`[${rangeArea.currency}]`);
                    var templateResult = compiledTemplate({
                        index: value.woodIndex,
                        qmRange: rangeArea.price,
                        character: value.woodIndex + ', ' + gradingScale[value.gradingScale],
                        price: rangePrice.price
                    });
                    additionalMarkup += templateResult;
                });
                $additionalMarkupTpl.html(additionalMarkup);
                $(config.calculatorOverlayMany).hide();

            }
            if (productData.hasOwnProperty('individualPrices') && !productData.many && !productData['currentSorting']) {
                $.each(productData['individualPrices'], function (index, value) {
                    $rowRange.find('.character-value').html(value.woodIndex + ', ' + gradingScale[value.gradingScale]);
                });
                $rowRange.show();
            }
        }

        if ( dashboardData ) {
            $('input#zip').val(dashboardData['zip']);
            $('input#area').val(dashboardData['size']);
            $('select#country').val(dashboardData['country']);
            $('select#country').material_select();
        }

        $calculationFormReset.show();
        $rowRangeTable.show();

        return true;

    };


    OverlayCalculator.prototype.verifyCurrentPageProduct = function(favs){

        var identifierToVerify = $('.teaser__product .favourites__action__wrapper').data('fav-id');

        var productSorting = $('[data-product-sorting-value]').get(0);
        var productSortingIndex = false;

        if ( productSorting ) {
            productSortingIndex = $(productSorting).attr('data-product-sorting-value');
        }

        var productExistInFavs = false;
        var productData = {};
        var dashboardData = favs['dashboard'];

        favs['content']['products'].filter(function(element, index, array) {
            if ( element.identifier == identifierToVerify ) {
                if( element.many ) {
                    if( productSortingIndex ) {
                        element['price'] = element['individualPrices'][productSortingIndex]['price'];
                        element['character'] = 'find me 181';
                        element['qmRange'] = element['individualPrices'][productSortingIndex]['qmRange'];
                        element['currentSorting'] = productSortingIndex;
                    }
                    productExistInFavs = true;
                } else {
                    if ( productSortingIndex == element['selected']['wood'] ) {
                        productExistInFavs = true;
                    } else {
                        productExistInFavs = false;
                    }
                }
                productData = element;
            }
        });


        var returnValues = [];
        returnValues['exist'] = productExistInFavs;
        returnValues['product'] = productData;
        returnValues['dashboard'] = dashboardData;

        return returnValues;

    };

    return OverlayCalculator

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlayCalculator.js